import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskNgoSize({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();

  const [memberCount, setMemberCount] = useState("");
  const [numberOfPeopleHelpedYearly, setNumberOfPeopleHelpedYearly] =
    useState("");
  const [annualBudget, setAnnualBudget] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.memberCount) setMemberCount(loggedInUser.memberCount);
      if (loggedInUser.numberOfPeopleHelpedYearly)
        setNumberOfPeopleHelpedYearly(loggedInUser.numberOfPeopleHelpedYearly);
      if (loggedInUser.annualBudget) setAnnualBudget(loggedInUser.annualBudget);
    }
  }, []);

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Ngo Size"
      skipID={"ngoStatOnboardingSkipped"}
      title={"Tell us about your scale"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          label={"Member Count"}
          value={memberCount}
          onChange={extractEventValue(setMemberCount)}
        />
        <MaterialInput
          label={"Number of people helped yearly"}
          value={numberOfPeopleHelpedYearly}
          onChange={extractEventValue(setNumberOfPeopleHelpedYearly)}
        />

        <MaterialInput
          label={"Annual Budget"}
          value={annualBudget}
          onChange={extractEventValue(setAnnualBudget)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { memberCount, numberOfPeopleHelpedYearly, annualBudget },
      });

      setLoading(false);

      let newLoggedInUser = {
        ...loggedInUser,
        memberCount,
        numberOfPeopleHelpedYearly,
        annualBudget,
      };

      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
